import * as React from 'react';
export const IcDistribution = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M19 10a2 2 0 10-2-2 1.37 1.37 0 000 .19l-3.3 2.35a2.999 2.999 0 00-.72-.36V5.72A2 2 0 0014 4a2 2 0 10-4 0 2 2 0 001 1.72v4.46A3 3 0 009.18 12H6.72A2 2 0 005 11a2 2 0 100 4 2 2 0 001.72-1h2.46a3.1 3.1 0 001.08 1.44l-.75 2.63A2 2 0 1012 20a2 2 0 00-.56-1.39l.75-2.61a2.88 2.88 0 001.33-.41L16 17.66V18a2 2 0 102-2 1.909 1.909 0 00-.68.13L14.81 14c.115-.321.18-.659.19-1a2.76 2.76 0 00-.13-.82l3.31-2.36A2 2 0 0019 10z'
      fill='currentColor'
    />
  </svg>
);
